import { Box } from "@mui/material";
import React from "react";
import PageTitle from "../base/PageTitle";
import ActiveAlertsView from "../views/ActiveAlerts/ActiveAlertsView";

interface Props {}

const AlertsPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Active Alerts" />
      <ActiveAlertsView />
    </Box>
  );
};

export default AlertsPage;
